import { create } from 'zustand';

/**
 * Discrete features that can be paywalled. Each value drives feature-
 * specific copy in `<PaywallModal />` (kicker / title / subtitle) so
 * adding a new gated surface is a one-line change here plus a copy
 * entry in the modal.
 */
export type PaywallFeature =
  | 'quiz'
  | 'learn-article'
  | 'egg-shop'
  | 'learn-with-ollie'
  | 'vocabulary-bookmark'
  | 'activity-pdf';

export interface PaywallState {
  open: boolean;
  /**
   * Last opened feature. We keep it set after `closePaywall` so the
   * Radix close animation has the right copy to render through the
   * fade-out — a `null` here would flash a blank modal on close.
   */
  feature: PaywallFeature | null;
  openPaywall: (feature: PaywallFeature) => void;
  closePaywall: () => void;
}

/**
 * PaywallStore — global driver for the single `<PaywallModal />` mounted
 * at the App root. Any component can `usePaywallStore.getState().openPaywall('quiz')`
 * (or via the `usePaywall()` hook) to surface the upgrade prompt without
 * having to thread its own modal state. Not persisted — this is purely
 * runtime UI.
 */
export const usePaywallStore = create<PaywallState>((set) => ({
  open: false,
  feature: null,
  openPaywall: (feature) => set({ open: true, feature }),
  closePaywall: () => set({ open: false }),
}));
